import { MDXProvider } from '@mdx-js/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { useMDXComponents } from './mdx-components'
import './pages/globals.css'

const Root = () => {
  const components = useMDXComponents({})

  return (
    <HelmetProvider>
      <BrowserRouter>
        <MDXProvider components={components}>
          <App />
        </MDXProvider>
      </BrowserRouter>
    </HelmetProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
)
